export const WIX_EVENTS_FQDN = 'wix.events.v1.event:';
export const WIX_EVENTS_TICKET_DEFINITION_FQDN = 'wix.events.v1.ticket_definition:';
export const WIX_EVENTS_TICKET_DEFINITION_FQDN_ALL_VERSIONS = 'wix.events.*.ticket_definition:';
//# sourceMappingURL=fqdn.js.map